import {aiVideoGeneratorServerlessUrl} from '../constants'
import {postForMedia} from '../utils'
import type {UserRequestInfo} from '@wix/document-services-types'

export interface VideoParam {
    width: string
    height: string
    imgWidth: string
    imgHeight: string
    hint: string
}

export interface VideoParams {
    videos: Record<string, VideoParam>
    siteType: string
    businessTerm: string
    siteDescription: string
    photoTheme: string | undefined
    userRequestInfo?: UserRequestInfo
}
export const fetchVideos = async (serverFacade: any, paramsMap: VideoParams): Promise<Record<string, string>> =>
    postForMedia<Record<string, string>>(serverFacade, aiVideoGeneratorServerlessUrl, paramsMap)
